import { useQuery } from '@tanstack/react-query';

import { api, getQueryProps, isTruthy } from 'common';

/**
 * The Staff role works, but only if the staff member is in the same practice as the user.
 * If not, the API will error out, and the UI may just show a UUID or error.
 */
export const AllowedGetUserApiRoles = new Set([api.User.Role.Admin, api.User.Role.Staff]);

interface UseUserApiProps {
  userId: string;
}

export function useUserApi(props: UseUserApiProps) {
  const { userId } = props;

  return useQuery({
    ...getQueryProps(api.client.User, 'findOneById', userId),
    enabled: isTruthy(userId),
    retry: 0,
  });
}
